const productList = [
    {
        id: 'nix1',
        title: '内衣物洗烘一体机「智享版」',
        category: 'washing',
        appshow: true,
        passshow: true,
        manual: 'http://manual.ezhousetech.net/电子说明书/DN_nix2电子说明书（增加水管）-20250319-v2.pdf',
        // manual: 'http://manual.ezhousetech.net/电子说明书/DN_nix2电子说明书（增加水管）-20260104-v5.pdf',
        assiImage: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/nix2/%E6%B7%BB%E5%8A%A0%E5%8A%A9%E7%90%86%E6%B5%B7%E6%8A%A5.png',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/nix2/%E4%BA%A7%E5%93%81%E9%80%89%E6%8B%A9-1.png'
      },
      {
        id: 's1',
        title: '内衣物洗烘一体机「悦享版」',
        category: 'washing',
        appshow: true,
        passshow: false,
        manual: 'http://manual.ezhousetech.net/电子说明书/MW1A 电子说明书（标准版）加水管-20241203-V1.pdf',
        // manual: 'http://manual.ezhousetech.net/电子说明书/MW1A 电子说明书（标准版）加水管-20260104-V3.pdf',
        assiImage: '',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%85%AC%E5%85%B1%E5%9B%BE%E7%89%87/%E6%A0%87%E5%87%86%E7%89%88.png'
      },
      {
        id: 'win1',
        title: '内衣物洗烘一体机「净护版」',
        category: 'washing',
        appshow: false,
        passshow: true,
        manual: 'http://manual.ezhousetech.net/电子说明书/DN-MW2BMW2DMW2E-说明书-20241217-v1.pdf',
        assiImage: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/winix/%E5%9B%BE%E7%89%87/%E6%B7%BB%E5%8A%A0%E7%A7%81%E4%BA%BA%E5%8A%A9%E7%90%86.png',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/winix/%E5%9B%BE%E7%89%87/winix%E8%BF%9B%E6%B0%B4%E9%80%89%E6%8B%A9.png'
      },
      {
        id: 'wv1',
        title: '内衣物洗烘一体机「免安装水箱-悦享版」',
        category: 'washing',
        appshow: true,
        passshow: false,
        manual: 'http://manual.ezhousetech.net/电子说明书/MW1C 电子说明书（大水箱版）加水管-20241203-V1.pdf',
        assiImage: '',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%85%AC%E5%85%B1%E5%9B%BE%E7%89%87/%E6%B0%B4%E7%AE%B1%E7%89%88.png'
      },
      {
        id: 'wt1',
        title: '内衣物洗烘一体机「免安装水箱-灵悦版」',
        category: 'washing',
        appshow: false,
        passshow: true,
        manual: 'http://manual.ezhousetech.net/电子说明书/DN_nix2-电子说明书-（大水箱版）20250416-v4.pdf',
        // manual: 'http://manual.ezhousetech.net/电子说明书/DN_nix2-电子说明书-（大水箱版）-20260104-v3.pdf',
        assiImage: 'http://manual.ezhousetech.net/水箱灵悦版/wtassi.png',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E6%B0%B4%E7%AE%B1%E7%81%B5%E6%82%A6%E7%89%88/%E4%BA%A7%E5%93%81%E9%80%89%E6%8B%A9-%E7%81%B5%E6%82%A6.png?id=1'
      },
      {
        id: 'dxm1',
        title: '内衣物洗烘一体机「双舱云星版」',
        category: 'dxm',
        appshow: false,
        passshow: true,
        manual: 'http://manual.ezhousetech.net/%E5%8F%8C%E8%88%B1%E4%BA%91%E6%98%9F%E7%89%88/%E5%8F%8C%E6%B3%A2%E8%BD%AE%E6%B4%97%E8%A1%A3%E6%9C%BA-%E7%94%B5%E5%AD%90%E8%AF%B4%E6%98%8E%E4%B9%A6-20260123-v4_compressed.pdf',
        assiImage: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/%E6%B7%BB%E5%8A%A0%E5%8A%A9%E7%90%86%E6%B5%B7%E6%8A%A5.jpg',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E6%98%9F%E7%89%88/17694993388319.png'
      },
      {
        id: 'dryer1',
        title: '小热石热泵烘干机',
        category: 'dryer',
        appshow: true,
        passshow: false,
        manual: 'http://manual.ezhousetech.net/电子说明书/DN烘干机使用说明.pdf?v=4.0',
        assiImage: '',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%85%AC%E5%85%B1%E5%9B%BE%E7%89%87/%E6%A0%87%E5%87%86%E7%89%88.png'
      },
      {
        id: 'dwm1',
        title: '内衣物洗烘一体机「双舱云镜版」',
        category: 'dwm',
        appshow: false,
        passshow: true,
        manual: 'http://manual.ezhousetech.net/双舱云镜版/双筒洗衣机-电子说明书.pdf?v=1.0',
        // manual: 'http://manual.ezhousetech.net/双舱云镜版/双筒洗衣机-电子说明书-20260104-v8.pdf',
        assiImage: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/%E6%B7%BB%E5%8A%A0%E5%8A%A9%E7%90%86%E6%B5%B7%E6%8A%A5.jpg',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/%E4%BA%91%E9%95%9C%E7%89%88-%E5%A3%81%E6%8C%82.png'
      },
      {
        id: 'dgm1',
        title: '内衣物洗烘一体机「双舱云镜版·壁挂款」',
        category: 'dwm',
        appshow: false,
        passshow: true,
        manual: 'http://manual.ezhousetech.net/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/%E5%A3%81%E6%8C%82%E6%AC%BE%E8%AF%B4%E6%98%8E%E4%B9%A6-20260303-V2.pdf',
        assiImage: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/%E6%B7%BB%E5%8A%A0%E5%8A%A9%E7%90%86%E6%B5%B7%E6%8A%A5.jpg',
        image: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/%E4%BA%91%E9%95%9C%E7%89%88-%E5%A3%81%E6%8C%82.png'
      }
  ]

  // 分类映射表
const productCategories = {
    washing: productList.filter(p => p.category === 'washing'),
    dryer: productList.filter(p => p.category === 'dryer'),
    dxm: productList.filter(p => p.category === 'dxm'),
    dwm: productList.filter(p => p.category === 'dwm')
}
  
  // 获取指定分类的产品列表
function getProductsByCategory(category ) {
    return productCategories[category] || []
}

function getProductById(id) {
    return productList.find(p => p.id === id) || null;
  }
  
export { productList, productCategories, getProductsByCategory, getProductById }


// WEBPACK FOOTER //
// ./src/config/products.js